import { Form } from "antd";

import { getUdfComponent } from "common/utils";
import { useFetchAllUserUdfCustomFieldsQuery } from "features/userDefinedFields/agencyPortal/userUserDefinedFieldsAPI";

export default function UserCustomFields() {
  const { data: userCustomFields = [] } = useFetchAllUserUdfCustomFieldsQuery();
  return (
    <>
      {userCustomFields.map((field) => (
        <Form.Item
          label={field.name}
          name={["customFields", field.slug]}
          key={field.id}
          rules={[{ required: field.isRequired }]}
        >
          {getUdfComponent(field)}
        </Form.Item>
      ))}
    </>
  );
}
